import { render, staticRenderFns } from "./rolesAdd.vue?vue&type=template&id=8e73fb6e&scoped=true&"
import script from "./rolesAdd.vue?vue&type=script&lang=js&"
export * from "./rolesAdd.vue?vue&type=script&lang=js&"
import style0 from "./rolesAdd.vue?vue&type=style&index=0&id=8e73fb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e73fb6e",
  null
  
)

export default component.exports